/**
 * Defines the default flags for the refx booking app
 */
export const DEFAULT_FEATURE_FLAGS: {[key: string]: 'dev' | boolean;} = {};
